export interface RegisterContent {
  readonly lines: readonly string[];
  readonly linewise: boolean;
}

export interface Registers {
  readonly entries: ReadonlyMap<string, RegisterContent>;
}

export const EMPTY_REGISTERS: Registers = { entries: new Map() };

/** 無名レジスタ（`"`）の名前。オペレータによる削除・変更内容の既定の格納先。 */
export const UNNAMED_REGISTER = '"';

export function getRegister(registers: Registers, name: string): RegisterContent | undefined {
  return registers.entries.get(name);
}

export function withRegister(
  registers: Registers,
  name: string,
  content: RegisterContent,
): Registers {
  const entries = new Map(registers.entries);
  entries.set(name, content);
  return { entries };
}
